module.exports = __webpack_public_path__ + "img/person-check.66b97b9c.svg";